import { Box, BoxProps, Text, TextProps, Tip } from 'grommet';
import { Logout, StatusGood, StatusWarning } from 'grommet-icons';
import { Right, RightStatus } from 'lib/api';
import { capitalize } from 'lodash';
import { getRightStatusColor } from 'src/utils/styling';

export type RightStatusDisplayProps = BoxProps & {
  right: Partial<Right>;
  textProps?: TextProps;
};

export const RightStatusDisplay = ({ right, textProps, ...props }: RightStatusDisplayProps) => {
  const statusColor = getRightStatusColor(right.status);

  return (
    <Box {...props}>
      <Tip content={`Status: ${capitalize(right.status)}`}>
        <Box direction="row" align="center" gap="xsmall">
          {right.status === RightStatus.ACTIVE && <StatusGood size="1rem" color={statusColor} />}
          {right.status === RightStatus.EXPIRED && <StatusWarning size="1rem" color={statusColor} />}
          {right.status === RightStatus.RELEASED && <Logout size="1rem" color={statusColor} />}

          <Text truncate color={statusColor} weight={500} size="small" {...textProps}>
            {right.status?.toLocaleUpperCase()}
          </Text>
        </Box>
      </Tip>
    </Box>
  );
};
